import React from "react";
import { NavLink as Link } from "react-router-dom";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import PartnerLogo from "../../images/Partner-Managment.png";
import LeadLogo from "../../images/Lead-Management.png";
import ApplicationLogo from "../../images/Application.png";

const RMDashboardList = () => {
  return (
    <div>
      <div className="log-avs">
        <img src={Logo} alt="" />
      </div>
      <div className="list-contnt">
        <ul className="list">
          <li className="">
            <Link className="ListItem" to="/RMDashboard/PartnerManagement">
              <img src={PartnerLogo} alt="" className="sidebarIcon" />
              <span className="list-Text"> Partner Management</span>
            </Link>
          </li>

          {/* <li>
            <p>
              <Link className="ListItem" to="/RMDashboard/LeadManagement">
                <img src={LeadLogo} alt="" className="sidebarIcon" />
                <span className="list-Text">Lead Management</span>
              </Link>
            </p>
          </li> */}
          {/* <li>
            <Link className="ListItem" to="/RMDashboard/ApplicationsListing">
              <img src={ApplicationLogo} alt="" className="sidebarIcon" />
              <span className="list-Text">Applications Listing</span>
            </Link>
          </li> */}

          {/* <li>
            <Link className="ListItem" to="/RMDashboard/AccessManagement">
            <img src={AccessLogo} alt="" className="sidebarIcon" />
            <span className="list-Text">
            Access Management</span>    
            </Link>
          </li>
          <li>
            <Link className="ListItem" to="/RMDashboard/MasterManagement">
            <img src={MasterLogo} alt="" className="sidebarIcon" />
            <span className="list-Text">
            Master Management</span>    
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default RMDashboardList;
